import { FEATURE_FLAGS } from '../../../featureFlags';
import IssueClustersIndex from './IssueClustersIndex.vue';
import IssueClusterDetail from './IssueClusterDetail.vue';
import SuggestionsInbox from './SuggestionsInbox.vue';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.ISSUE_CLUSTERS,
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: 'issue-clusters',
    name: 'issue_clusters_index',
    component: IssueClustersIndex,
    meta: commonMeta,
  },
  {
    path: 'issue-clusters/suggestions',
    name: 'issue_cluster_suggestions',
    component: SuggestionsInbox,
    meta: commonMeta,
  },
  {
    path: 'issue-clusters/:clusterId(\\d+)',
    name: 'issue_cluster_detail',
    component: IssueClusterDetail,
    meta: commonMeta,
    props: route => ({ clusterId: route.params.clusterId }),
  },
];

export default routes;
